export const ADDITIONAL_KEY = Object.freeze({
    DOCUMENT: 'TYPE_DOCUMENT',
    IMAGE: 'TYPE_IMAGE',
    AUDIO: 'TYPE_AUDIO',
    VIDEO: 'TYPE_VIDEO',
    VOICE_NOTE: 'TYPE_VOICE_NOTE'
})